<ngx-loading [show]="loading" [config]="{ backdropBackgroundColour: 'rgba(0,0,0,0.6)' }" #customLoadingTemplate></ngx-loading>
<p *ngIf="!listGroupSettingModel && !loading"><em>Sem dados</em></p>

<div *ngIf="listGroupSettingModel" class="containerSearchTxtOrder" style="margin-bottom: 7px; margin-top: -9px;">
  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important;" [disabled]="loading" (click)="refrehPage()">
    <img title="Atualizar" style="cursor: pointer; cursor: pointer; height: 24px; width: 24px; cursor: inherit; margin-right: 15px;" src="/update.svg" />
  </button>

  <button class="btn btn-outline btn-refresh" style="border-color: transparent !important; visibility: hidden;" [disabled]="loading" >
    <img title="Buscar" style="height: 24px; width: 24px; cursor: inherit; margin-right: 5px;" src="/search.svg" />
  </button>

  <input type="text" (ngxInputSearch)="doSearch($event)"
         (emptyInput)="doSearchClear()"
         stringLength="0" class="searchTxt" placeholder="" disabled  style=" visibility: hidden;"/>
</div>

<table class='table table-striped table-without-width table-with-minwidth' aria-labelledby="tableLabel" align="center" *ngFor="let itemGroupSettingModel of listGroupSettingModel; let iG = index">
  <thead>
    <tr>
      <th style="text-align:center;" colspan="3" title="{{ itemGroupSettingModel.groupName }}">{{ itemGroupSettingModel.groupName }}</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let itemSettings of itemGroupSettingModel.settings; let iS = index">
      <td class="txt-label" title="{{ itemSettings.label }}">{{ itemSettings.label }}</td>
      <td class="txt-value" title="{{ itemSettings.value }}">{{ itemSettings.value }}</td>
      <td class="txt-action">
        <button *ngIf="currentUser.userPermission.account.write" class="btn" style="border-color: transparent !important;" [disabled]="loading" (click)="openModal('modalEditSetting', iG, iS, $event)">
          <img style="cursor: pointer; border-radius: 20px;" src="../../../assets/editar.svg" class="btn-img-nocircle details" />
        </button>
      </td>
    </tr>
  </tbody>
</table>

<div class="modal" id="modalEditSetting" role="dialog" *ngIf="groupId!=null && propId!=null">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{listGroupSettingModel[groupId].groupName}}</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalEditSetting')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <label>{{listGroupSettingModel[groupId].settings[propId].label}}</label>
        <textarea id="settingValue" name="settingValue" type="text" #input class="form-control input-modal" autocomplete="false" tabindex="1">{{listGroupSettingModel[groupId].settings[propId].value}}</textarea>
      </div>
      <div class="modal-footer">
        <div *ngIf="!processingConfirmation">
          <button class="btn btn-outline" [disabled]="loading" (click)="editSave()">Confirmar</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="modalErrors" role="dialog" *ngIf="errorMessages">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header modal-header-alert">
        <h3>Erro ao salvar alteração</h3>
        <button type="button" class="btn btn-default btnCloseModal" data-dismiss="modal" (click)="closeModal('modalErrors')">Fechar</button>
      </div>
      <div class="modal-body" style="max-height: calc(100vh - 366px); overflow-y: auto;">
        <ul>
          <li *ngFor ="let errorMessage of errorMessages">{{errorMessage.message}}</li>
        </ul>
      </div>
    </div>
  </div>
</div>
